import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { environment } from '../../environments/environment';
import { Product } from '../models/data.model';
import { StartupService } from './startup.service';

@Injectable()
export class ProductService {
  constructor(private http:HttpClient,private startupService:StartupService) {
   }

  getProduct(nodeAlias:string):Observable<Product>{
    return this.http.get<Product>(`${environment.apiUrl}/${this.startupService.websiteName}/${window.location.href.split('/')[3]}/product/${nodeAlias}`)  
    .catch((error:any) => Observable.throw(error.json().error || 'Server error'));
    
  }
}



// WEBPACK FOOTER //
// ./src/app/services/product.service.ts